import { GetterTree } from "vuex";
import { RootState } from "@/store/modules/general/types";
import { API_PEDIDO } from "./types";

type FinalizarPedidoGetterTree = GetterTree<API_PEDIDO, RootState>;

export const getters: FinalizarPedidoGetterTree = {
  
};
